import { render, staticRenderFns } from "./FeedbackPreview.vue?vue&type=template&id=1c482d3d&scoped=true&"
import script from "./FeedbackPreview.vue?vue&type=script&lang=js&"
export * from "./FeedbackPreview.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPreview.vue?vue&type=style&index=0&id=1c482d3d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c482d3d",
  null
  
)

export default component.exports